import React from 'react';
import Header from "../../components/layout/Header";
import Banner from "../../components/home/Banner";
import Footer from "../../components/layout/Footer";

const Fashion = () => {
    const banners = [
        "/fashion_hero_new.png",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/3b12ea642f89f924.jpg?q=20",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/d34fc9b3a0429712.jpg?q=20",
    ];

    return (
        <div style={{ backgroundColor: '#f1f2f4', minHeight: '100vh', paddingTop: '128px' }}>
            <Header />

            <div style={{ maxWidth: '1440px', margin: '0 auto', padding: '12px 16px' }}>
                {/* 1. Hero Banner Section */}
                <div style={{ marginBottom: '24px', borderRadius: '24px', overflow: 'hidden', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }}>
                    <Banner images={banners} height="350px" />
                </div>

                {/* 2. Sub-Category Immersive Circles */}
                <div style={{ backgroundColor: 'white', padding: '40px', borderRadius: '32px', marginBottom: '32px', boxShadow: '0 1px 2px rgba(0,0,0,0.06)' }}>
                    <div style={{ display: 'flex', gap: '64px', overflowX: 'auto', paddingBottom: '16px', justifyContent: 'flex-start' }} className="no-scrollbar">
                        {[
                            { name: "Men's Wear", img: "/men_fashion_cat.png", bg: "#f0f4ff" },
                            { name: "Women's Style", img: "/women_fashion_cat.png", bg: "#fff0f6" },
                            { name: "Kids' Corner", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/489f076e03328e75.jpg?q=20", bg: "#f6ffed" },
                            { name: "Footwear", img: "/footwear_cat.png", bg: "#fff7e6" },
                            { name: "Best of Watches", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/24930e466d181938.jpg?q=20", bg: "#e6fffa" },
                            { name: "Accessories", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/3b12ea642f89f924.jpg?q=20", bg: "#fff1f0" }
                        ].map((cat, i) => (
                            <div key={i} style={{ minWidth: '120px', cursor: 'pointer', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ width: '100px', height: '100px', backgroundColor: cat.bg, padding: '16px', border: '2px solid white', borderRadius: '50%', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: '0.4s' }}>
                                    <img src={cat.img} alt={cat.name} style={{ height: '100%', objectFit: 'contain' }} />
                                </div>
                                <p style={{ fontSize: '14px', fontWeight: '800', textAlign: 'start', marginTop: '12px', color: '#222', margin: '12px 0 0 0' }}>{cat.name}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 3. Season's Best Deals - Immersive Cards */}
                <div style={{ marginBottom: '40px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                        <h2 style={{ fontSize: '26px', fontWeight: '900', margin: 0 }}>Season's Best Deals</h2>
                        <span style={{ backgroundColor: '#e53e3e', color: 'white', padding: '4px 12px', borderRadius: '8px', fontSize: '14px', fontWeight: '600' }}>LIMITED TIME ONLY</span>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '32px' }}>
                        {[
                            { title: "Premium Shirts", off: "Flat 50% Off", img: "/mens_wear_new.png", brand: "Roadster" },
                            { title: "Designer Ethnic", off: "Min. 60% Off", img: "/womens_ethnic_new.png", brand: "Libas" },
                            { title: "Casual Footwear", off: "Under ₹999", img: "/footwear_new.png", brand: "Puma" }
                        ].map((item, i) => (
                            <div
                                key={i}
                                style={{
                                    height: '450px',
                                    borderRadius: '32px',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    cursor: 'pointer',
                                    transition: '0.5s'
                                }}
                            >
                                <img src={item.img} alt={item.title} style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
                                <div
                                    style={{
                                        position: 'absolute',
                                        inset: 0,
                                        background: 'linear-gradient(to top, rgba(0,0,0,0.95), rgba(0,0,0,0.4), transparent)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-end',
                                        padding: '40px'
                                    }}
                                >
                                    <p style={{ color: '#fc8181', fontWeight: '900', fontSize: '14px', marginBottom: '4px', letterSpacing: '0.1em', margin: '0 0 4px 0' }}>{item.brand.toUpperCase()}</p>
                                    <h3 style={{ color: 'white', fontSize: '24px', marginBottom: '8px', fontWeight: '900', margin: '0 0 8px 0' }}>{item.title}</h3>
                                    <p style={{ color: '#68d391', fontWeight: '900', fontSize: '24px', margin: 0 }}>{item.off}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 4. Brand Spotlight Section */}
                <div style={{ marginBottom: '80px' }}>
                    <h2 style={{ fontSize: '26px', marginBottom: '32px', textAlign: 'start', fontWeight: '900' }}>Brand </h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '24px' }}>
                        {[
                            { name: "ADIDAS", bg: "#f8f9fa", off: "40-60% OFF" },
                            { name: "PUMA", bg: "#fff5f5", off: "UP TO 70% OFF" },
                            { name: "LEVIS", bg: "#f1f3f5", off: "BUY 2 GET 1" },
                            { name: "USPA", bg: "#fff4e6", off: "FLAT 50% OFF" },
                            { name: "NIKE", bg: "#f3f0ff", off: "MIN. 30% OFF" },
                            { name: "ZARA", bg: "#fff0f6", off: "SEASON SALE" }
                        ].map((brand, i) => (
                            <div
                                key={i}
                                style={{
                                    backgroundColor: brand.bg,
                                    padding: '32px',
                                    borderRadius: '24px',
                                    cursor: 'pointer',
                                    border: '1px solid #eee',
                                    textAlign: 'center',
                                    transition: '0.3s'
                                }}
                            >
                                <p style={{ fontWeight: '900', fontSize: '18px', color: '#333', margin: '0 0 4px 0' }}>{brand.name}</p>
                                <p style={{ fontWeight: '700', fontSize: '12px', color: '#e53e3e', margin: 0 }}>{brand.off}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Fashion;

